import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scaleMmpia'
})
export class ScaleMmpiaPipe implements PipeTransform {

  transform(value: any, arg: String, se:any): unknown {
    let response = [];
    for (let i in value){
      if (arg!='Clínicas'&&arg!='Lingoes'){
        if (value[i].type==arg) {
          value[i].scale = i;
          if (arg!='Suplementarias') response.push(value[i]);
          else{
            if ((i=='A'||i=='INM'||i=='Mac-R'||i=='PPA'||i=='R'||i=='RA')){
              if (response.indexOf(value[i]) == -1) response.push(value[i]);
            } 
            if ((value[i].title.indexOf('A ')==0||value[i].title.indexOf('INM')==0||value[i].title.indexOf('Mac-R')==0||value[i].title.indexOf('PPA')==0||value[i].title.indexOf('R')==0||value[i].title.indexOf('RA')==0)) {
              if (response.indexOf(value[i]) == -1) response.push(value[i]);
            }
          }
        }
      }
      if (arg=='Clínicas'){
        if (i=='D'||i=='Dp'||i=='Hi'||i=='Pa'||i=='Es'||i=='Ma'||i=='Hs'||i=='Mf'||i=='Pt'||i=='Is'||value[i].title.indexOf('Hs ')==0||value[i].title.indexOf('D ')==0||value[i].title.indexOf('Hi ')==0||value[i].title.indexOf('Dp ')==0||value[i].title.indexOf('Mf ')==0||value[i].title.indexOf('Pa ')==0||value[i].title.indexOf('Pt ')==0||value[i].title.indexOf('Es ')==0||value[i].title.indexOf('Ma ')==0||value[i].title.indexOf('Is ')==0){
          value[i].scale = i;
          response.push(value[i])
        }
      }
      if (arg=='Lingoes'){
        if (value[i].type=='Clínicas'&&i!='Hs'&&i!='D'&&i!='Hi'&&i!='Dp'&&i!='Mf'&&i!='MfM'&&i!='Pa'&&i!='Pt'&&i!='Es'&&i!='Ma'&&i!='Is'&&i!='L'&&i!='?'&&i!='F'&&i!='K'&&i!='F1'&&i!='F2'&&i!='VRIN'&&i!='TRIN'){
          value[i].scale = i;
          if (i.indexOf(se)==0||(value[i].title.indexOf(se)==0&&value[i].title!='D - Depresión'&&value[i].title!='Discordia familiar'&&value[i].title!='Es - Esquizofrenia')) {
            if (se=='D'&&(value[i].scale!='Dp1'&&value[i].scale!='Dp2'&&value[i].scale!='Dp3'&&value[i].scale!='Dp4'&&value[i].scale!='Dp5')&&(value[i].title.indexOf('Dp')==-1)){
              if (response.indexOf(value[i])==-1) response.push(value[i])
            }else if (se!='D') if (response.indexOf(value[i])==-1) response.push(value[i])
          }
        }
      }
    }
    return response;
  }
}
